import html2canvas from 'html2canvas';

export const ExportToImage = async (
  elementIds: string[],
  fileName: string = 'exported-image.png',
  excludeElementId: string | null = null // Add an optional parameter to exclude elements
) => {
  try {
    const canvasArray: HTMLCanvasElement[] = [];
    
    // Temporarily hide the excluded element if an ID is provided
    let excludedElement: HTMLElement | null = null;
    if (excludeElementId) {
      excludedElement = document.getElementById(excludeElementId);
      if (excludedElement) {
        excludedElement.style.visibility = 'hidden';
      }
    }

    for (const id of elementIds) {
      const element = document.getElementById(id);
      if (element) {
        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2, // Increase scale for better resolution
          logging: true, // Enable logging to troubleshoot
          //backgroundColor: null,
          //allowTaint: true,
          foreignObjectRendering: true,
          //canvas: undefined,
        });
        canvasArray.push(canvas);
      } else {
        console.warn(`Element with ID ${id} not found.`);
      }
    }

    // Restore the excluded element's visibility
    if (excludedElement) {
      excludedElement.style.visibility = 'visible';
    }

    if (canvasArray.length === 1) {
      const link = document.createElement('a');
      link.download = fileName;
      link.href = canvasArray[0].toDataURL('image/png');
      link.click();
    } else if (canvasArray.length > 1) {
      const combinedCanvas = document.createElement('canvas');
      const ctx = combinedCanvas.getContext('2d')!;
      const totalWidth = Math.max(...canvasArray.map((c) => c.width));
      const totalHeight = canvasArray.reduce((sum, c) => sum + c.height, 0);

      combinedCanvas.width = totalWidth;
      combinedCanvas.height = totalHeight;

      let offsetY = 0;
      for (const canvas of canvasArray) {
        ctx.drawImage(canvas, 0, offsetY);
        offsetY += canvas.height;
      }

      const link = document.createElement('a');
      link.download = fileName;
      link.href = combinedCanvas.toDataURL('image/png');
      link.click();
    }
  } catch (error) {
    console.error('Failed to export image:', error);
  }
};
